import React from 'react';
import { useIntl } from 'react-intl';
import styled from 'styled-components';

import { TextButton } from '@xing-com/crate-lebenslauf-button';
import { useReadVitaReactiveVariable } from '@xing-com/crate-lebenslauf-hooks';
import { IconArrowLeft, IconArrowRight } from '@xing-com/icons';
import { xdlColorTextTertiary } from '@xing-com/tokens';

type PaginationProps = {
  pageVisible: number;
  setPageVisible: (page: number) => void;
  totalPages: number;
  className?: string;
};

const Container = styled.div`
  align-items: center;
  display: flex;
  color: ${xdlColorTextTertiary};

  & button,
  button:disabled {
    color: ${xdlColorTextTertiary};
  }
`;
const Status = styled.span`
  font-weight: 700;
  font-size: 14px;
`;

export const Pagination: React.FC<PaginationProps> = ({
  pageVisible,
  totalPages,
  setPageVisible,
  className,
}) => {
  const { formatMessage } = useIntl();
  const { theme } = useReadVitaReactiveVariable();

  React.useEffect(() => setPageVisible(0), [theme?.template]);

  const setPageVisibleValidated = (page: number): void => {
    if (page >= 0 && page < totalPages) {
      setPageVisible(page);
    }
  };
  return (
    <Container className={className}>
      <TextButton
        icon={IconArrowLeft}
        onClick={() => setPageVisibleValidated(pageVisible - 1)}
        disabled={pageVisible === 0}
        aria-label={formatMessage({
          id: 'CRATE_VITA_PREVIEW_PAGINATION_LEFT',
        })}
      />
      <Status>
        {pageVisible + 1}/{totalPages}
      </Status>
      <TextButton
        icon={IconArrowRight}
        onClick={() => setPageVisibleValidated(pageVisible + 1)}
        disabled={pageVisible === totalPages - 1}
        aria-label={formatMessage({
          id: 'CRATE_VITA_PREVIEW_PAGINATION_RIGHT',
        })}
      />
    </Container>
  );
};
